import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Role } from 'app/core/models';

@Component({
  selector: 'app-add-role-modal',
  templateUrl: './add-role-modal.component.html',
  styleUrls: ['./add-role-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddRoleModalComponent {
  form = new FormGroup({
    id: new FormControl(),
    label: new FormControl('', [Validators.required, Validators.minLength(3)]),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Partial<Role>,
    public matDialogRef: MatDialogRef<AddRoleModalComponent>,
  ) {
    if (data) {
      this.form.get('label').setValue(data.label);
      this.form.get('id').setValue(String(data.id));
    }
  }

  save(): void {
    this.matDialogRef.close(this.form.getRawValue());
  }
}
